var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropDown',{attrs:{"options":_vm.options,"selected-option-index":_vm.selectedOptionIndex,"place-holder":_vm.placeHolder},on:{"set-selected-option":function($event){return _vm.setNewSelectedOption($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }